module.exports = __webpack_public_path__ + "img/Desk Stationeryd20.a936abf0.jpg";